export const C_ROUTER_NAME_INDEX = 'home'
export const C_ROUTER_NAME_ROOT_ARTICLE = 'root-article'
export const C_ROUTER_NAME_ARTICLE_ITEM = 'article-item'

export const C_ROUTER_NAME_PROMOTION_PAGE_KINDEREDU = 'promotion-page-kinderedu'
